import { NextPage } from 'next';

import Layout from '../components/Layout';
import SignupAndLogin from '../components/SignupAndLogin';

const SignupPage: NextPage = () => {
  return (
    <Layout>
      <SignupAndLogin state="login" />
    </Layout>
  );
};

export default SignupPage;
